import { useHomeSecurity } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { GetUsersResponse, useGetUsersMutation } from '@services';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useWorksiteSelectionPageVM = () => {
    const navigate = useNavigate();
    const { worksiteId: contextWorksiteId, setWorksiteId: setContextWorksiteId } = useHomeSecurity();

    const [selectedOperatorId, setSelectedOperatorId] = useState<string>('');
    const [worksiteId, setWorksiteId] = useState<number | null>(contextWorksiteId);
    const [operatorsOptions, setOperatorsOptions] = useState<
        (GetUsersResponse['operators'][number] & {
            id: string;
            label: string;
        })[]
    >([]);
    const [worksitesOptions, setWorksitesOptions] = useState<{ id: string; label: string }[]>([]);

    const [getUsers, { data: getUsersData }] = useGetUsersMutation();

    useEffect(() => {
        getUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (getUsersData) {
            setOperatorsOptions(
                getUsersData.operators.map((operator) => ({
                    ...operator,
                    id: operator.id_operator,
                    label: operator.name
                }))
            );
        }
    }, [getUsersData]);

    const handleOperatorChange = (operatorId: string) => {
        setSelectedOperatorId(operatorId);
        setWorksitesOptions([]);
        setWorksiteId(null);

        const selectedOperator = getUsersData?.operators.find((op) => op.id_operator === operatorId);
        if (selectedOperator) {
            const worksites = selectedOperator.worksites.map((worksite) => ({
                id: worksite.id,
                label: worksite.name
            }));
            setWorksitesOptions(worksites);
        }
    };

    const handleContinue = () => {
        if (worksiteId) {
            setContextWorksiteId(worksiteId);
            navigate('/sante-securite/home-security/menu');
        }
    };

    const canContinue = useMemo(() => {
        return selectedOperatorId && worksiteId;
    }, [selectedOperatorId, worksiteId]);

    return {
        operatorsOptions,
        worksitesOptions,
        selectedOperatorId,
        handleOperatorChange,
        worksiteId,
        setWorksiteId,
        handleContinue,
        canContinue
    };
};
